import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselViewportFn = /* @__PURE__ */ createRecipe('carousel-viewport', {}, [])

const carouselViewportVariantMap = {}

const carouselViewportVariantKeys = Object.keys(carouselViewportVariantMap)

export const carouselViewport = /* @__PURE__ */ Object.assign(memo(carouselViewportFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselViewport',
  __getCompoundVariantCss__: carouselViewportFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselViewportVariantKeys,
  variantMap: carouselViewportVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselViewportVariantKeys)
  },
  getVariantProps: carouselViewportFn.getVariantProps,
})